import React from 'react'

export default ({ children, ...props }) => (
  <div style={{ padding: '0px 50px', ...props.style }}>
    {children}
  </div>
)
